import { Box, Center, Divider, Image, Text, useToast } from "@chakra-ui/react";
import { useState } from "react";
import OrderCell from "./components/OrderCell";
import { useQuery } from "@tanstack/react-query";
import { callOrderHistoryApi } from "./api";
import { ResStatus } from "lib/api/enum";
import { OrderModel } from "lib/api/model";
import usePathNavigate from "lib/hook/usePathNavigate";
import withAuth from "lib/hook/withAuth";

const OrderHistory = () => {
    const { pathNavigate } = usePathNavigate();
    const toast = useToast();

    const [orderList, setOrderList] = useState<OrderModel[]>([]);

    useQuery(
        ["callOrderHistoryApi"],
        () => {
            return callOrderHistoryApi({ view_type: 2 });
        },
        {
            onSuccess: (data) => {
                console.log("callOrderHistoryApi : ", data);

                if (data.status === ResStatus.RES_SUCCESS) {
                    setOrderList(data.command.order_list);
                } else {
                    toast({
                        title: "오류",
                        description: `${data.status} \n` + data.result_message,
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                        position: "top",
                    });
                }
            },
            onError: (err: any) => {
                toast({
                    title: "오류",
                    description: err.message,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top",
                });
            },
        }
    );

    const onClickDetail = (detail: OrderModel) => {
        console.log(detail);
        pathNavigate(`/order/orderdetail/${detail.order_id}`);
    };

    return (
        <Box h="100vh" bgColor={orderList.length > 0 ? "white" : "#f5f5f5"}>
            <Center
                w="100%"
                h="4rem"
                bgColor={"white"}
                fontSize="1.25rem"
                fontWeight={"semibold"}
                top={0}
                zIndex="1"
            >
                주문내역
            </Center>
            {orderList.length > 0 ? (
                <Box mx="20px" pt="2.25rem" pb="1.25rem">
                    {orderList.map((v: OrderModel, index: number) => (
                        <Box
                            key={`history_index${index}`}
                            onClick={() => onClickDetail(v)}
                        >
                            <OrderCell data={v} />
                            {index < orderList.length - 1 && (
                                <Divider my="1.25rem" />
                            )}
                        </Box>
                    ))}
                </Box>
            ) : (
                <Box>
                    <Center mt="8.4375rem">
                        <Image
                            src="/assets/images/img_orderBag_emptyState.svg"
                            w="15rem"
                            h="15rem"
                        />
                    </Center>
                    <Center mt="2.375rem">
                        <Text fontSize={"0.938rem"} fontWeight="medium">
                            주문내역이 없어요
                        </Text>
                    </Center>
                </Box>
            )}
        </Box>
    );
};

export default withAuth(OrderHistory);
